<div class="container  pl-0 pr-0">
  <div style="padding: 10px 0px"></div>
    <form class="card-body" [formGroup]="formGroup" (submit)="enviarVotacion()">
      <div class="title-pregunta"><strong>VOTACI&Oacute;N {{preguntaBD.orden}}:</strong> {{preguntaBD.descripcion}}
      </div>
        <mat-divider></mat-divider>
        <div style="padding: 5px 0px"></div>
        <div *ngIf="preguntaBD.tipoPregunta == 2" class="alert alert-info" role="alert">
          {{preguntaBD.mensajePregunta}}
        </div>

        <div *ngIf="preguntaBD.tipoPregunta == 1" >
          <mat-radio-group class="opcion-radio-group"  name="codigo"  [formControl]="votacionValidacion" required>
              <mat-radio-button class="opcion-radio-button" *ngFor="let opcion of preguntaBD.opciones" [value]="opcion">
                {{opcion.descripcion}}
              </mat-radio-button>
          </mat-radio-group>
        </div>

        <div *ngIf="preguntaBD.tipoPregunta == 2" >
          <div *ngFor="let opcion of preguntaBD.opciones" >
              <mat-checkbox
              (change)="onChange($event)" [value]="opcion.descripcion">{{opcion.descripcion}}</mat-checkbox>
            </div>
        </div>

        <div style="text-align: center">
            <button mat-raised-button color="primary" type="submit" [disabled]="preguntaBD.tipoPregunta == 1 ? !votacionValidacion.valid : 'false'">
              VOTAR</button>
        </div>
</form>
</div>
